import * as React from 'react';

import { ButtonTheme } from '../../enums';
import { PageTitleSettings } from '../../interfaces';

import {
  ButtonsContainer,
  ChildrenContainer,
  Container,
  LinkButton,
  StyledButton,
  Title,
  InnerContainer,
  DescriptionContainer
} from './pageTitle.styled';
import { PageTitleProps } from './pageTitle.types';

export const PageTitle: React.FC<PageTitleProps> = (props: PageTitleProps): JSX.Element => {
  const { pageTitleSettings, children, className }: PageTitleProps = props;
  const {
    title,
    withUnderline = true,
    buttonLabel,
    buttonAction,
    linkLabel,
    linkAction,
    secondButtonLabel,
    secondButtonAction,
    description
  }: PageTitleSettings = pageTitleSettings;

  return (
    <Container
      className={className}
      $withUnderline={withUnderline}
      $withChildren={!!buttonLabel || !!linkLabel || !!children || !!secondButtonLabel}
      $withDescription={!!description}
    >
      <Title>{title}</Title>
      <InnerContainer>
        {description && (
          <DescriptionContainer>{description}</DescriptionContainer>
        )}
        {(!!buttonLabel || !!linkLabel || !!children || !!secondButtonLabel) && (
          <ButtonsContainer>
            {!!linkLabel && <LinkButton onClick={linkAction}>{linkLabel}</LinkButton>}
            {!!secondButtonLabel && (
              <StyledButton
                buttonTheme={ButtonTheme.SecondarySolidSmall}
                label={secondButtonLabel}
                onClick={secondButtonAction}
              />
            )}
            {!!buttonLabel && (
              <StyledButton
                buttonTheme={!secondButtonLabel && !children ? ButtonTheme.PrimaryBig : ButtonTheme.PrimarySmall}
                label={buttonLabel}
                onClick={buttonAction}
              />
            )}
            {!!children && <ChildrenContainer>{children}</ChildrenContainer>}
          </ButtonsContainer>
        )}
      </InnerContainer>
    </Container>
  );
};
